import { useEnablePermission } from "@/hooks/auth/useEnablePermission";
import { useUserAuthrity } from "@/hooks/auth/useUserAuthrity";
import type { ReactNode } from "react";
import type { PermissionRole } from "@/constants/premissions";

interface UserPermission {
    value?: string
}

interface PremissionGuardProps {
    children: ReactNode
    permissions?: PermissionRole[]
}

const hasPermission = (userPremissions: UserPermission[], permissions: PermissionRole[]) => {
    return permissions.some(permission => {
        return !!userPremissions.find(_userPermission => _userPermission?.value === permission)
    })
}

export const PremissionGuard = ({ children, permissions }: PremissionGuardProps) => {
    const { data: userAuthority } = useUserAuthrity()
    const userPremissions: UserPermission[] = userAuthority?.permissions || []
    const enablePermission = useEnablePermission()

    if (!enablePermission) {
        return children
    }

    if (!permissions) {
        return children;
    }

    if (!hasPermission(userPremissions, permissions)) {
        return null
    }

    return children;
};
